import React from 'react';

import PrePurchaseDisclaimer from '../../components/PrePurchaseDisclaimer';
import PrePurchaseScreener from '../../components/PrePurchaseScreener';

import {
  usePrePurchaseModalContext,
  PrePurchaseModalActionsTypes,
} from '../../contexts/PrePurchaseModal';

// Types ----------

interface PrePurchaseWrapperProps {
  addToCart?: (
    e: React.FormEvent<HTMLButtonElement>,
    callback?: () => void,
  ) => void;
}

// PrePurchaseWrapper ------

const PrePurchaseWrapper: React.FC<PrePurchaseWrapperProps> = (props) => {
  const { addToCart } = props;

  const prePurchaseModalContext = usePrePurchaseModalContext();

  const {
    state: { prePurchaseDisclaimerData, prePurchaseScreenerData },
  } = prePurchaseModalContext;

  const closeScreenerHandler = () => {
    prePurchaseModalContext?.dispatch({
      type: PrePurchaseModalActionsTypes.SetPrePurchaseScreener,
      payload: {
        isPrePurchaseScreenerOpen: false,
      },
    });
  };

  /**
   * Toggle the disclaimer component
   * @param shouldOpen boolean value, true if it should be opened, false if it should close
   */
  const toggleDisclaimerHandler = (shouldOpen: boolean) => {
    prePurchaseModalContext?.dispatch({
      type: PrePurchaseModalActionsTypes.SetPrePurchaseDisclaimer,
      payload: {
        isPrePurchaseDisclaimerOpen: shouldOpen,
        prePurchaseDisclaimerData: prePurchaseDisclaimerData,
      },
    });
  };

  /**
   * Handles ineligible selection on screener
   */
  const ineligibleHandler = () => {
    prePurchaseModalContext?.dispatch({
      type: PrePurchaseModalActionsTypes.SetPrePurchaseScreener,
      payload: {
        isPrePurchaseScreenerOpen: false,
      },
    });

    toggleDisclaimerHandler(true);
  };

  /**
   * Handles eligible selection on screener
   * @param e React Event Object
   */
  const eligibleHandler = (e: React.FormEvent<HTMLButtonElement>) => {
    const elegibleCallback = prePurchaseModalContext?.state.elegibleCallback;

    if (typeof elegibleCallback === 'function') {
      elegibleCallback();
    } else if (addToCart) {
      addToCart(e);
    } else {
      throw new Error('Please set an eligible callback function');
    }
  };

  return (
    <>
      {prePurchaseDisclaimerData ? (
        <PrePurchaseDisclaimer
          body={prePurchaseDisclaimerData.body}
          callToAction={prePurchaseDisclaimerData.callToAction}
          title={prePurchaseDisclaimerData.title}
          open={
            prePurchaseModalContext?.state.isPrePurchaseDisclaimerOpen || false
          }
          openHandler={() => toggleDisclaimerHandler(false)}
        />
      ) : null}
      {prePurchaseScreenerData ? (
        <PrePurchaseScreener
          eligibleOptionCallback={(e) => eligibleHandler(e)}
          ineligibleOptionCallback={ineligibleHandler}
          modalOpen={
            prePurchaseModalContext?.state.isPrePurchaseScreenerOpen || false
          }
          modalOpenCallback={closeScreenerHandler}
          screenerData={prePurchaseScreenerData}
        />
      ) : null}
    </>
  );
};

// Export ---------

export default PrePurchaseWrapper;
